
<h2 mat-dialog-title>IA Document List</h2>
<mat-dialog-content>
  <div class="table-responsive">
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Document Name</th>
          <th>Document Type</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of statusList">
          <td>{{ item.documentName }}</td>
          <td>{{ item.documentType }}</td>
          <td class="text-center">
            <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="item.documentPath"
               (click)="onDownload(item.documentPath, item.documentName); $event.preventDefault()" style="text-decoration: underline; cursor: pointer">
              <i class="bi bi-download"></i> Download
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="w-100 mt-3">
    <div class="">
      <div class="card mb-3">
        <div class="card-header"><h2>Event Attendance Table</h2></div>
        <div class="card-body">
          <form [formGroup]="form1">
            <div class="col-lg-12 col-sm-12">
              <div class="search-container">
                <mat-form-field class="search-input w-75" appearance="outline">
                  <mat-label>Search</mat-label>
                  <input matInput formControlName="searchControl" />
                </mat-form-field>
                <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form1.get('searchControl')?.value ?? '')" id="btnSearch">
                  <i class="bi bi-search fs-4"></i>
                </button>
              </div>
              <div *ngIf="form1.get('searchControl')?.invalid && (form1.get('searchControl')?.touched)">
                <small *ngIf="form1.get('searchControl')?.errors?.['pattern']" class="text-danger">
                  Invalid search term.
                </small>
              </div>
            </div>



            <div class="table-responsive">
              <table mat-table [dataSource]="AttendanceDetailsData" class="mat-elevation-z8 table table-striped table-bordered table-hover" matSort matSortActive="CreatedDate" matSortDirection="asc" matSortDisableClear>

                <!-- Sr. No Column -->
                <ng-container matColumnDef="SrNo">
                  <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
                  <td mat-cell *matCellDef="let ar"> {{ar.rowNum}} </td>
                </ng-container>
                <!-- Udyam Column -->
                <ng-container matColumnDef="UdyamRegistrationNumber">
                  <th mat-header-cell *matHeaderCellDef> Udyam Registration Number </th>
                  <td mat-cell *matCellDef="let ar"> {{ar.udyamRegistrationNumber}} </td>
                </ng-container>




                <!-- Created Date Column -->
                <ng-container matColumnDef="CreatedDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
                  <td mat-cell *matCellDef="let ar"> {{ar.createdDate}} </td>
                </ng-container>


                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedAttendanceColumns"></tr>
                <!-- Data Row -->
                <tr mat-row *matRowDef="let row; columns: displayedAttendanceColumns;"></tr>
                <!-- No Data Row -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="7">No data matching the filter</td>
                </tr>
              </table>
            </div>

            <!-- Paginator -->
            <mat-paginator #paginator
                           class="demo-paginator"
                           (page)="onPageChange($event)"
                           [length]="length"
                           [pageSize]="pageSize"
                           [showFirstLastButtons]="showFirstLastButtons"
                           [pageSizeOptions]="pageSizeOptions"
                           [hidePageSize]="hidePageSize"
                           [pageIndex]="pageIndex"
                           aria-label="Select page">
            </mat-paginator>


          </form>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="btn btn-danger" mat-dialog-close>Close</button>
</mat-dialog-actions>

